import React from "react";
import {
  FaGithub,
  FaLinkedin,
  FaFacebook,
  FaWhatsapp,
  FaInstagram,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { MdArrowCircleUp } from "react-icons/md";
import { Link } from "react-scroll";

const Contact = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          <FaLinkedin size={30} />
        </>
      ),
      href: "https://www.linkedin.com/in/smith-mallick-ba8065132/",
      style: "rounded-bl-xl rounded-tl-xl",
    },
    {
      id: 2,
      child: (
        <>
          <FaGithub size={30} />
        </>
      ),
      href: "https://github.com/smithmallick149",
    },
    {
      id: 3,
      child: (
        <>
          <HiOutlineMail size={30} />
        </>
      ),
      href: "mailto:smithmallickjbn@gmail.com",
    },
    {
      id: 4,
      child: (
        <>
          <BsFillPersonLinesFill size={30} />
        </>
      ),
      href: "/Smith_Frontend_Resume.pdf",
      download: true,
    },
    {
      id: 5,
      child: (
        <>
          <FaInstagram size={30} />
        </>
      ),
      href: "https://www.instagram.com/s_m_i_t_h_7/?hl=en",
    },
    {
      id: 6,
      child: (
        <>
          <FaFacebook size={30} />
        </>
      ),
      // href:"https://www.facebook.com/smith.mallick.9/",
      href: "https://m.me/smith.mallick.9",
    },
    {
      id: 7,
      child: (
        <>
          <FaWhatsapp size={30} />
        </>
      ),
      href: "https://web.whatsapp.com/send?phone= [+917504786353]",
      style: "rounded-br-xl rounded-tr-xl",
    },
  ];

  return (
    <div
      name="contact"
      className="w-full h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Contact
          </p>
          <p className="py-6">Submit the form below to get in touch with me</p>
        </div>

        <div className=" flex justify-center items-center">
          {/* login to getform.io to check */}
          <form
            action="https://getform.io/f/5b8ab27d-f336-4be6-b87e-e1fd46573f49"
            method="POST"
            className=" flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              className="my-2 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="text"
              name="Subject"
              placeholder="Enter your subject"
              className="mb-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              placeholder="Enter your message"
              rows="10"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>

            <button className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
              Let's talk
            </button>
          </form>
        </div>
        <div
          class="
          rounded-3xl
             sticky
             bottom-0
             flex
             items-center
             lg:hidden
             justify-center
             "
        >
          {links.map(({ id, child, href, style, download }) => (
            <li
              key={id}
              className={
                "flex justify-between items-center w-15 h-14 px-2 duration-200 bg-gray-500" +
                " " +
                style
              }
            >
              <a
                href={href}
                className="flex justify-between items-center w-full text-white"
                download={download}
                target="_blank"
                rel="noreferrer"
              >
                {child}
              </a>
            </li>
          ))}
        </div>
      </div>
      <div className="flex-end bottom-0 mt-[-100px]">
        <Link to="home" smooth duration={300}>
          <button
            className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 items-center rounded-xl hover:scale-230 duration-300 float-right"
          >
            <span className="group-hover:rotate-90 duration-300">
              <MdArrowCircleUp size={35} />
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Contact;
